import { createExperiencePage } from "../shared/createExperiencePage";

const defaultContent = {
  meta: {
    title: "Northern Lights Tour in Lapland | Cold Experience",
    description:
      "Chase the aurora borealis with local guides who read the sky, the weather and the camera so you can enjoy the show.",
    keywords:
      "northern lights tour lapland, aurora experience sweden, aurora photography lapland",
    ogTitle: "Northern Lights Experience in Swedish Lapland",
    ogDescription:
      "Private small-group northern lights hunts with photo support, warm shelters and hot drinks.",
    ogImage: "/og/northern-lights.jpg",
    siteUrl: "https://coldexperience.se",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      name: "Northern Lights Tour Lapland",
      description:
        "Aurora hunts by minibus and snowmobile with real-time forecasts, warm shelter and photography guidance.",
      image: "/og/northern-lights.jpg",
      provider: {
        "@type": "Organization",
        name: "Cold Experience Lapland",
      },
      location: {
        "@type": "Place",
        name: "Råstrand, Swedish Lapland",
      },
      url: "https://coldexperience.se/en/northern-lights",
    },
  },
  media: {
    videoSrc: "/optimized_videos/norrsken1-opt.mp4",
    poster: "/images/Nya_bilder/IMG_2963.webp",
    introVideo: "/optimized_videos/norrsken2-opt.mp4",
    introPoster: "/images/Nya_bilder/IMG_2963.webp",
    scale: 1.25,
  },
  hero: {
    title: "Northern Lights Tour",
    description:
      "Stand beneath the dancing aurora and capture the moment with guides who grew up under these skies.",
    primaryButton: {
      label: "Book Northern Lights Tour",
      target: "book",
    },
    secondaryButton: {
      label: "Check Aurora Forecast",
      target: "contact",
    },
  },
  intro: {
    heading: "Follow the colours across the sky",
    paragraphs: [
      "We monitor several weather models and solar forecasts to take you where the skies are clearest each night.",
      "Stay warm in our kota hut with open fire, reindeer hides and hot lingonberry juice while we wait for the show.",
    ],
  },
  features: [
    {
      icon: "Eye",
      title: "Aurora expertise",
      description:
        "Daily analysis of KP index, cloud cover and local micro climates.",
    },
    {
      icon: "Camera",
      title: "Photography support",
      description:
        "Tripods and manual camera settings help from our in-house photographer.",
    },
    {
      icon: "Thermometer",
      title: "Stay warm",
      description:
        "Thermal suits, boots and hand warmers included for every guest.",
    },
    {
      icon: "Snowflake",
      title: "Flexible transport",
      description:
        "Travel by minibus, snowmobile or snowshoes depending on conditions.",
    },
  ],
  sectionsHeading: "What happens during the tour",
  sections: [
    {
      id: "bestConditions",
      title: "Before the lights",
      icon: "CheckCircle",
      items: [
        "Real-time weather tracking to choose the best direction",
        "Briefing on how the aurora works and what to expect",
        "Dress in supplied thermal gear for -30°C nights",
        "Drive to remote viewing locations away from light pollution",
        "Snacks and hot drinks in our heated hut",
        "Optional snowshoe walk to panoramic viewpoints",
      ],
    },
    {
      id: "expectations",
      title: "During the hunt",
      icon: "Star",
      items: [
        "Immediate camera support when the lights appear",
        "Storytelling about Sami legends and science",
        "Time-lapse and portrait photos taken for your group",
        "Warm blankets and reindeer hides for extra comfort",
        "Flexible end time depending on aurora activity",
        "Aurora report emailed with photos the next morning",
      ],
    },
  ],
  dayProgram: {
    title: "Evening schedule",
    steps: [
      {
        icon: "Clock",
        title: "18:00 Meet & brief",
        description:
          "Gather at base camp, gear up and review the forecast.",
      },
      {
        icon: "Wind",
        title: "Travel to clear skies",
        description:
          "Drive 30-60 minutes to the best aurora window of the night.",
      },
      {
        icon: "Snowflake",
        title: "Aurora watching",
        description:
          "Enjoy the lights from our heated shelter or outside on the snow.",
      },
      {
        icon: "Camera",
        title: "Photo session",
        description:
          "Capture portraits and tips for shooting the lights yourself.",
      },
    ],
  },
  closing: {
    title: "Let us find your aurora",
    description:
      "Share your travel dates and we will recommend the best night for your northern lights tour.",
    primaryButton: {
      label: "Plan Your Aurora Night",
      target: "book",
    },
    secondaryButton: {
      label: "Message our guides",
      target: "contact",
    },
    showStarRating: true,
    ratingText: "Local success rate above 90%",
  },
  settings: {
    showFooter: false,
  },
};

export default createExperiencePage({
  translationKey: "northernLights",
  defaultContent,
  routeKey: "northern-lights",
});
